// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2WrPT","info":"PatientInfo_info__1vQ5v"};